// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3":"4057e296","698":"3b162781","721":"f65aa214"}[chunkId] + ".css";
};